export enum DuplicableObjectArrayEnum {
  "organization",
  "lotresult",
  "lottender",
  "tenderingparty",
  "settledcontract",
  "procurementprojectlot"
}
